module.exports = __webpack_public_path__ + "static/media/WarningFilled.5d2ba0d0.svg";